import type { RouteObject } from 'react-router';

import { NotFoundChildRoute } from 'src/app/NotFoundChildRoute';

// every panel is a real route, so a failing endpoint is a sendable link
export const developerPlatformRoutes: RouteObject[] = [
  {
    index: true,
    lazy: () =>
      import('./overview/OverviewPanel').then((m) => ({
        Component: m.OverviewPanel,
      })),
  },
  {
    path: 'credentials',
    lazy: () =>
      import('./credentials/CredentialsPanel').then((m) => ({
        Component: m.CredentialsPanel,
      })),
  },
  {
    path: 'webhooks',
    lazy: () =>
      import('./webhooks/WebhooksPanel').then((m) => ({
        Component: m.WebhooksPanel,
      })),
  },
  {
    path: 'webhooks/:endpointId',
    lazy: () =>
      import('./webhooks/EndpointDetailPanel').then((m) => ({
        Component: m.EndpointDetailPanel,
      })),
  },
  {
    path: 'deliveries',
    lazy: () =>
      import('./deliveries/DeliveriesPanel').then((m) => ({
        Component: m.DeliveriesPanel,
      })),
  },
  {
    path: '*',
    element: (
      <NotFoundChildRoute
        routePath="/developer"
        linkText="Go back to the Developer Platform"
      />
    ),
  },
];
